import { styled } from 'next-yak'
import * as plume from '@ulule/owl-kit-components/next'

export const EditButtonWrapper = styled.div`
  right: 5px;
  top: 0px;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    position: absolute;
    right: 0px;
  }
`

export const CreateButtonWrapper = styled.div<{ $large?: boolean }>`
  border: 1px solid ${plume.COLORS.PRIMARY_SAND_100};
  display: flex;
  flex-direction: row;
  height: ${({ $large }) => ($large ? '150px' : 'auto')};
  justify-content: ${({ $large }) => ($large ? 'center' : 'baseline')};
  margin-bottom: ${({ $large }) => ($large ? '30px' : '0px')};
  padding: 21px 18px;
  text-align: center;
  transition: 0.3s ease;

  &:hover {
    box-shadow: ${plume.EFFECTS.SHADOW_1};
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    flex-direction: ${({ $large }) => ($large ? 'column' : 'row')};
  }
`
